// Classnames helper. Filters falsy + joins, then runs tailwind-merge so a
// LATER class correctly overrides an EARLIER conflicting Tailwind utility
// (e.g. a consumer className 'w-8' wins over a base 'w-9'). Same signature
// and falsy-filtering contract as before — only conflict resolution changes.
import { twMerge } from 'tailwind-merge'

export function cn(...parts: Array<string | false | null | undefined>): string {
  return twMerge(parts.filter(Boolean).join(' '))
}
